import { useCallback } from "react";
import { popupOrderActions } from "../actions/ui/popup-order.actions";
import { PopupOrderItem, PopupOrderStatus, PopupType } from "../types/state/ui/PopupOrderState";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector";
import { ListBuilder } from "../utils/ListBuilder";
import { roles } from "../constants";
import { user } from "../user";

export function usePopupOrder(popup: PopupType) {
    const dispatch = useAppDispatch();
    const current = useAppSelector(s => s.ui.popupOrder.order.find(x => x.status === PopupOrderStatus.Wait));

    const canShow = current?.popup === popup
    const markAsShown = useCallback(() =>
        canShow ? dispatch(popupOrderActions.markAsShown()) : undefined, [canShow, dispatch]
    );
    const markAsWait = useCallback((popupType: PopupType) =>
        dispatch(popupOrderActions.markAsWait(popupType)), [dispatch]
    );

    return { canShow, markAsShown, markAsWait };
}

export function usePopupOrderInit() {
    const dispatch = useAppDispatch();

    return () => {
        const hasEvalPopupAccess = user.hasRoles(...roles.startEvalAccess());

        const order = new ListBuilder<PopupOrderItem>()
            .addWhen(() => hasEvalPopupAccess, { popup: 'Eval', status: PopupOrderStatus.Wait })
            .addWhen(() => hasEvalPopupAccess, { popup: 'EvalStart', status: PopupOrderStatus.Inactive })
            .add({ popup: 'Webinar', status: PopupOrderStatus.Wait })
            .add({ popup: 'Releases', status: PopupOrderStatus.Wait })
            .addWhen(() => user.hasRoles(roles.SellerTrader), { popup: 'RequestDirectBidding', status: PopupOrderStatus.Wait })
            .addWhen(() => user.hasRoles(roles.BrokerDealerTrader), { popup: 'RequestAllToAllBidding', status: PopupOrderStatus.Wait })
            .result()

        dispatch(popupOrderActions.init(order));
    }
}